import { useMarketplaceApi } from '@/context/marketplace.context';
import { createSessionSelectionSyncAdapter } from '@/components/group-tables/selection-sync-adapter';
import { useGroupTableSelection } from '@/components/group-tables/use-group-table-selection';

type SelectableProduct = {
    id: string;
};

type UseProductsTableSelectionArgs = {
    accessToken: string;
    selectionSessionId: string;
    pickedProducts: string[];
    setPickedProducts?: (value: string[]) => void;
    maxSelectedItems: number | null;
    visibleProducts: SelectableProduct[];
    pagedProducts: SelectableProduct[];
};

export const useProductsTableSelection = ({
    accessToken,
    selectionSessionId,
    pickedProducts,
    setPickedProducts,
    maxSelectedItems,
    visibleProducts,
    pagedProducts,
}: UseProductsTableSelectionArgs) => {
    const { productsApi } = useMarketplaceApi();

    const selectionSync = createSessionSelectionSyncAdapter({
        sessionId: selectionSessionId,
        setPickedIds: setPickedProducts,
        syncAddIds: (addIds) =>
            productsApi.updateProductSelectionSession(selectionSessionId, { addIds }, { authToken: accessToken }),
        syncRemoveIds: (removeIds) =>
            productsApi.updateProductSelectionSession(selectionSessionId, { removeIds }, { authToken: accessToken }),
    });

    return useGroupTableSelection<SelectableProduct>({
        pickedIds: pickedProducts,
        setPickedIds: selectionSync.setPickedIds,
        maxSelectedItems,
        visibleItems: visibleProducts,
        pagedItems: pagedProducts,
        syncAddIds: selectionSync.syncAddIds,
        syncRemoveIds: selectionSync.syncRemoveIds,
    });
};
